<div class="app-body">
    <main class="main d-flex align-items-center">
        <div class="container">
            <div class="row">
                <div class="col-md-8 mx-auto">
                    <div class="card-group">
                        <div class="card p-4">
                            <div class="card-body">
                                <div *ngIf="(status$ | async) === 'FAILED'" role="alert" class="alert alert-danger">
                                    <strong>{{'admin.alerts.headerError'|translate}}</strong> {{'admin.alerts.errorOccured'|translate}}
                                </div>
                                <div *ngIf="(status$ | async) === 'VERIFICATION_SENT'" role="alert" class="alert alert-success">
                                    <h4 class="alert-heading">{{'admin.forgot.successHeader'|translate}}</h4>
                                    <p>{{'admin.account.receiveEmailMsg'|translate}}</p>
                                </div>
                                <app-email-form *ngIf="(status$ | async) !== 'VERIFICATION_SENT'" (submitEvent)="verify($event)"></app-email-form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>